import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModal } from 'src/app/app.model';

type AlertIntent = 'danger' | 'warning' | 'info';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css'],
})
export class AlertModalComponent {
  @Input() data: AlertModal = {
    message: '',
    yesAction: '',
    noAction: '',
    yesActionColor: '',
    noActionColor: '',
    image: ''
  };

  constructor(private activeModalService: NgbActiveModal) {}

  /** Heading; falls back to "Confirm" so legacy callers still render. */
  get title(): string {
    return this.data.title || 'Confirm';
  }

  /** Explicit data.intent wins; otherwise derive from the (already-passed) yesActionColor. */
  get intent(): AlertIntent {
    if (this.data.intent) return this.data.intent;
    const c = (this.data.yesActionColor || '').trim().toLowerCase();
    if (c === '#f04e5c' || c === 'red') return 'danger';
    if (c === '#ff8c00' || c === 'orange') return 'warning';
    return 'info';
  }

  get iconClass(): string {
    switch (this.intent) {
      case 'danger': return 'bi-trash';
      case 'warning': return 'bi-exclamation-triangle';
      default: return 'bi-question-circle';
    }
  }

  onClose(action: string) {
    this.activeModalService.close({ action });
  }
}
